export interface SessionMonitoringConfig {
  /**
    The url where the worker script can be found (default: assets/js/session-monitoring.worker.js)
   */
  workerUrl: string;
  /**
    The url which is called when the token needs to be refreshed
   */
  refreshUrl: string | null;
  /**
    The time it will take before the user will be idle in seconds (default: 6000)
   */
  idleTime: number;
  /**
    The duration the timeout warning will be shown in seconds (default: 900)
   */
  idleWarningTime: number;
  /**
    The interval in seconds at which the refresh endpoint is called while watching and not idle.
    Must be shorter than the token lifetime, or the token expires between two refreshes
    (default: 240)
   */
  keepAliveTime: number;
  /**
    Whether production mode is enabled (default: false)
   */
  prodMode: boolean;
}


export function sessionMonitoringConfig(
  config: Partial<SessionMonitoringConfig>
): SessionMonitoringConfig {
  return {
    workerUrl: 'assets/js/session-monitoring.worker.js',
    refreshUrl: null,
    idleTime: 6000,
    idleWarningTime: 900,
    keepAliveTime: 240,
    prodMode: false,
    ...config
  };
}
